/* Glass Automated Products: progressive enhancement for native Shopify pages. */
(() => {
  const header = document.querySelector('[data-gap-header]');
  const toggle = header?.querySelector('.gap-menu-toggle');
  const mobileNav = matchMedia('(max-width:800px)');
  const syncMenu = () => {
    const open = !!header?.classList.contains('menu-open') && mobileNav.matches;
    document.documentElement.classList.toggle('gap-menu-active', open);
    document.querySelectorAll('main, .shopify-section-group-footer-group').forEach(el => { el.inert = open; });
    if (header) document.documentElement.style.setProperty('--gap-header-height', `${header.querySelector('.gap-header-top').getBoundingClientRect().height}px`);
  };
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open)); header.classList.toggle('menu-open', open);
    syncMenu();
  });
  mobileNav.addEventListener('change', () => {
    if (!mobileNav.matches) { header?.classList.remove('menu-open'); toggle?.setAttribute('aria-expanded','false'); }
    syncMenu();
  });
  const scrollState=()=>header?.classList.toggle('is-scrolled',window.scrollY>16);
  addEventListener('scroll',scrollState,{passive:true});scrollState();
  addEventListener('resize',syncMenu,{passive:true});
  header?.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
    if (detail.open) header.querySelectorAll('details').forEach(other => { if (other !== detail) other.open = false; });
  }));
  document.addEventListener('keydown', event => {
    if(event.key==='Tab' && mobileNav.matches && header?.classList.contains('menu-open')) {
      const focusable=[...header.querySelectorAll('a,button,summary')].filter(el=>el.getClientRects().length>0);
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
    if (event.key !== 'Escape') return;
    const open = header?.querySelector('details[open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
    else if (header?.classList.contains('menu-open')) { toggle.click(); toggle.focus(); }
  });
  document.addEventListener('click', event => { if (header && !header.contains(event.target)) header.querySelectorAll('details').forEach(d => { d.open = false; }); });
  const footerMedia = matchMedia('(max-width:600px)');
  const setFooter = () => document.querySelectorAll('.gap-footer details').forEach(d => { d.open = !footerMedia.matches; });
  setFooter(); footerMedia.addEventListener('change', setFooter);
  function track(name, properties = {}) { window.gapTrack?.(name,properties); }
  document.querySelectorAll('[data-gap-event]').forEach(el => el.addEventListener('click', () => track(el.dataset.gapEvent)));
  try { const p = new URLSearchParams(location.search); const utm = {}; for (const k of ['utm_source','utm_medium','utm_campaign','utm_term','utm_content']) if (p.has(k)) utm[k] = p.get(k).slice(0,500); if (Object.keys(utm).length) sessionStorage.setItem('gap-utm', JSON.stringify(utm)); } catch (_) { /* Forms remain usable when storage is unavailable. */ }
  class SleeveBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.form = this.querySelector('form'); this.error = this.querySelector('[role=alert]');
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => { this.update(); track('spec_builder_change'); });
      this.form.addEventListener('submit', event => {
        event.preventDefault(); if (!this.update(true)) return;
        const url = new URL(this.dataset.quoteUrl, location.origin); url.searchParams.set('need','sleeve');
        for (const [k,v] of new FormData(this.form)) url.searchParams.set(k,v);
        location.assign(url.href);
      }); this.update();
    }
    update(report = false) {
      const f = this.form.elements, od = Number(f.od.value), length = Number(f.namedItem('length').value), wall = Number(f.wall.value), quantity = Number(f.quantity.value);
      f.wall.setCustomValidity('');
      if (Number.isFinite(od) && Number.isFinite(wall) && wall * 2 >= od) f.wall.setCustomValidity('Wall thickness must be less than half the outside diameter.');
      const valid = this.form.checkValidity();
      this.error.hidden = valid;
      this.error.textContent = valid ? '' : (f.wall.validationMessage || 'Enter positive dimensions and a whole-number quantity of at least 1.');
      if (!valid) { if (report) this.form.reportValidity(); return false; }
      const fmt = n => Number(n.toFixed(3)).toString();
      this.querySelector('[data-length-label]').textContent = `${fmt(length)} mm`;
      this.querySelector('[data-od-label]').textContent = `Ø ${fmt(od)} mm`;
      this.querySelector('[data-wall-label]').textContent = `WALL ${fmt(wall)} mm`;
      this.querySelector('[data-id]').textContent = `${fmt(od - 2 * wall)} mm`;
      this.querySelector('[data-quantity]').textContent = String(quantity);
      this.querySelector('[data-finish]').textContent = f.finish.selectedOptions[0].textContent;
      const radius = Math.max(23, Math.min(85, 490 * od / length / 2));
      const inset = Math.max(3, Math.min(radius - 2, radius * wall / (od / 2)));
      const y = 190 - radius, h = radius * 2, right = 590, left = 100;
      this.querySelector('[data-od-dimension]').setAttribute('d', `M615 ${y}h30M615 ${y+h}h30M635 ${y}v${h}M630 ${y+5}l10-10M630 ${y+h+5}l10-10`);
      const inner = radius - inset;
      let outerPath, innerPath;
      if (f.finish.value === 'dome-one') {
        outerPath = `M${left} ${y}H${right-radius}a${radius} ${radius} 0 0 1 0 ${h}H${left}Z`;
        innerPath = `M${left} ${y+inset}H${right-radius}a${inner} ${inner} 0 0 1 0 ${2*inner}H${left}`;
      } else if (f.finish.value === 'dome-both') {
        outerPath = `M${left+radius} ${y}H${right-radius}a${radius} ${radius} 0 0 1 0 ${h}H${left+radius}a${radius} ${radius} 0 0 1 0 -${h}Z`;
        innerPath = `M${left+radius} ${y+inset}H${right-radius}a${inner} ${inner} 0 0 1 0 ${2*inner}H${left+radius}a${inner} ${inner} 0 0 1 0 -${2*inner}Z`;
      } else {
        outerPath = `M${left} ${y}H${right}V${y+h}H${left}Z`;
        innerPath = `M${left} ${y+inset}H${right}M${left} ${y+h-inset}H${right}`;
      }
      this.querySelector('[data-tube-outer]').setAttribute('d',outerPath); this.querySelector('[data-tube-inner]').setAttribute('d',innerPath);
      const flange = this.querySelector('[data-flange]'); flange.style.display = f.finish.value === 'flanged' ? '' : 'none';
      flange.setAttribute('d',`M98 ${y-15}h15v${h+30}H98Z`);
      this.querySelector('svg').setAttribute('aria-label',`Quartz sleeve specification: outside diameter ${fmt(od)} millimeters, length ${fmt(length)} millimeters, wall ${fmt(wall)} millimeters, ${f.finish.selectedOptions[0].textContent}, quantity ${quantity}. Illustration not to scale.`);
      return true;
    }
  }
  if (!customElements.get('gap-spec-builder')) customElements.define('gap-spec-builder', SleeveBuilder);
})();
